import { setLocalStorage, getLocalStorage } from '@/utils/auth'
import { getInvoiceToken } from '@/api/invoice'
import { deepClone } from '@/utils'
import Cookies from 'js-cookie'

const state = {
    invoiceToken: Cookies.get('invoiceToken'),
    pendingBill: getLocalStorage('pendingBill'),
    infoAsUserInvoice: getLocalStorage('UserInvoiceInfo'),
    invoiceParkId: getLocalStorage('invoiceParkId'),
    invoiceInfo: {}
}

const mutations = {
    GET_TOKEN: (state, data) => {
        Cookies.set('invoiceToken', data, 7200)
        state.invoiceToken = data
    },
    SET_PENDING_BILL: (state, data) => {
        setLocalStorage('pendingBill', data)
        state.pendingBill = deepClone(data)
    },
    SET_Invoice_Info: (state, data) => {
        state.invoiceInfo = data
    },
    SET_USER_INVOICE_TITLE: (state, data) => {
        state.infoAsUserInvoice = deepClone(data)
    },
    SET_PARKID: (state, data) => {
        setLocalStorage('invoiceParkId', data)
        state.invoiceParkId = data
    },
}

const actions = {
    // 设置待处理发票停车场号
    SetParkId ({ commit }, data) {
        commit('SET_PARKID', data)
    },
    // 设置待处理发票单据数据
    SetInvoiceInfo ({ commit }, data) {
        commit('SET_Invoice_Info', data)
    },
    // 获取发票token
    GetToken ({ commit }, params) {
        return new Promise((resolve, reject) => {
            getInvoiceToken(params)
                .then(res => {
                    let data = res.rows;
                    if (res.result == 'SUCCESS' || res.result == 'success') {
                        commit("GET_TOKEN", data.access_token);
                    }
                    resolve(data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // 设置待处理发票单据
    SetPendingBill ({ commit }, data) {
        commit('SET_PENDING_BILL', data)
    },
    // 设置用户发票抬头
    SetUserInvoiceTitle ({ commit }, data) {
        commit('SET_USER_INVOICE_TITLE', data)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}